import Checkbox from 'src/components/checkbox/checkbox.vue'
import Gallery from 'src/components/gallery/gallery.vue'

// the files with one of them moved a place up (-1) or down (1)
export const moveFile = (files, file, delta) => {
  const from = files.findIndex((f) => f.id === file.id)
  const to = from + delta
  if (from === -1 || to < 0 || to >= files.length) return [...files]
  const moved = [...files]
  moved.splice(to, 0, ...moved.splice(from, 1))
  return moved
}

// The files of a post being written: the gallery to describe, reorder and
// remove them, the sensitive checkbox, and the indicator shown while files
// are dragged over the form (the form sends the drag events here).
export default {
  components: { Checkbox, Gallery },
  props: {
    files: { type: Array, required: true },
    descriptions: { type: Object, required: true },
    nsfw: Boolean,
    hideSensitive: Boolean,
    // no more files fit: dropping is refused
    full: Boolean,
  },
  emits: [
    'update:files',
    'update:descriptions',
    'update:nsfw',
    'drop',
    'play',
    'pause',
  ],
  expose: ['dragOver'],
  data() {
    return {
      dropIcon: 'hide',
      dropStopTimeout: null,
    }
  },
  methods: {
    remove(file) {
      this.$emit(
        'update:files',
        this.files.filter((f) => f.id !== file.id),
      )
    },
    move(file, delta) {
      this.$emit('update:files', moveFile(this.files, file, delta))
    },
    describe(file, text) {
      this.$emit('update:descriptions', {
        ...this.descriptions,
        [file.id]: text,
      })
    },
    dragOver(e) {
      e.dataTransfer.dropEffect = this.full ? 'none' : 'copy'
      if (e.dataTransfer?.types.includes('Files')) {
        clearTimeout(this.dropStopTimeout)
        this.dropIcon = 'show'
      }
    },
    dragStop() {
      // hidden after a delay: hiding on leave at once made it flicker
      clearTimeout(this.dropStopTimeout)
      this.dropIcon = 'fade'
      this.dropStopTimeout = setTimeout(() => (this.dropIcon = 'hide'), 500)
    },
    drop(e) {
      if (e.dataTransfer?.types.includes('Files')) {
        e.preventDefault() // text is still dropped into the field
        this.$emit('drop', e.dataTransfer.files)
        clearTimeout(this.dropStopTimeout)
        this.dropIcon = 'hide'
      }
    },
  },
  beforeUnmount() {
    clearTimeout(this.dropStopTimeout)
  },
}
